import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as HttpStatus from 'http-status-codes';
import MFAForm from './components/MFAForm';
import {
  sendOtp,
  verifyOtp,
  login,
  sendConfirmationEmail,
  sendConfirmationRequest,
  setErrorMessage,
  loginStatus,
} from './LoginAction';
import { fetchBroker } from '../../scenes/Admin/scenes/Broker/BrokerActions';
import { brokerInfoSelector } from '../../scenes/Admin/scenes/Broker/BrokerSelectors';
import { fetchOrganisations } from '../../scenes/Organisation/OrganisationAction';
import './Login.scss';

const Login = ({ loginStatus, setErrorMessage, close, ...otherProps }) => {
  useEffect(() => {
    setErrorMessage('');
  }, [setErrorMessage]);

  return (
    <>
      <MFAForm
        loginHasError={loginStatus !== HttpStatus.OK && loginStatus !== HttpStatus.FORBIDDEN}
        needResend={loginStatus === HttpStatus.FORBIDDEN}
        setErrorMessage={setErrorMessage}
        close={close}
        {...otherProps}
      />
      <p className="login-register-prompt">
        Don&apos;t have an account?{' '}
        <Link to="/onboarding/registration" onClick={close} className="login-register-link">
          Register here
        </Link>
      </p>
    </>
  );
};

const mapStateToProps = (state) => ({
  brokerInfo: brokerInfoSelector(state),
  ...state.loginReducer,
});

const mapDispatchToProps = {
  login,
  sendConfirmationEmail,
  setSendConfirmationRequest: sendConfirmationRequest,
  setErrorMessage,
  fetchBroker,
  fetchOrganisations,
  sendOtp,
  verifyOtp,
  setLoginStatus: loginStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
